function transformServerClock(data: { SC: string; ST: string }) {
  const { SC: code, ST: title } = data;

  return {
    code: code.toLowerCase(),
    title,
  };
}

export { transformServerClock };
